import submitIncentive from "@crescentParts/Handlers/Custom/Incentivehandler";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DatePicker, { DatePickerState } from "@insite/mobius/DatePicker/DatePicker";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Select from "@insite/mobius/Select";
import TextField from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    submitIncentive,
};

const mapStateToProps = (state: ApplicationState) => ({
    accountSettings: getSettingsCollection(state).accountSettings,
    returnUrl: getCreateAccountReturnUrl(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CommonStyles {
    form?: InjectableCss;
    maincntr?: InjectableCss;
    cntr1?: InjectableCss;
    itm1?: GridItemProps;
    gridItem?: GridItemProps;
    txtfld?: InjectableCss;
    button?: InjectableCss;
    submitButton?: ButtonPresentationProps;
}

export const commonStyles: CommonStyles = {
    form: {
        css: css`
            background: rgba(225, 221, 226, 0.3);
            /* margin: 60px 80px; */
            border-radius: 8px;
            //overflow-y: scroll;
            //height: 70vh;
            > [class^="GridWrapper"] {
                [class^="GridOffset"] {
                    margin: 0;
                    width: 100%;
                    [class^="GridWrapper"] {
                        max-width: none;
                    }
                }
            }
            [class^="ContentWrapper"] {
                padding: 20px 20px 0px 20px;
            }
        `,
    },
    itm1: {
        width: 12,
        css: css`
            flex-direction: column;
            padding: 0px 30px 30px 30px;
        `,
    },
    gridItem: {
        css: css`
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
        `,
    },

    txtfld: {
        css: css`
            border-radius: 8px !important;
        `,
    },
    button: {
        css: css`
            text-align: center;
            width: 100%;
            margin-top: 5px;
        `,
    },
};

const styles = commonStyles;
const StyledForm = getStyledWrapper("form");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const IncentiveForm = ({ submitIncentive, id }: Props) => {
    const contractorNameRequiredFieldMessage = siteMessage("Contractor Name is Required");
    const dateofSaleRequiredFieldMessage = siteMessage("Enter a valid Date");
    const invoiceNumberRequiredFieldMessage = siteMessage("Invoice Number is Required");
    const equipmentTypeRequiredFieldMessage = siteMessage("Equipment Type is Required");
    const listedManufacturerRequiredFieldMessage = siteMessage("Listed Manufacturer is required");
    const businessNameRequiredFieldMessage = siteMessage("Business Name is Required");
    const instlLocationAdrsRequiredFieldMessage = siteMessage("Installation Location is Required");
    const endUsrNameRequiredFieldMessage = siteMessage("End User Name is Required");
    const accntHldrphnRequiredFieldMessage = siteMessage("Account Holder Phone is Required");
    const validPhoneMsg = siteMessage("Enter a Valid Phone Number");
    const accntHldrMailRequiredFieldMessage = siteMessage("Account Holder Email is Required");
    const electricILAccntRequiredFieldMessage = siteMessage("Ameren IL Electric Account is Number");
    const indiUnitsSoldrequiredFieldMessage = siteMessage("Individual Units Sold Required");
    const emailFieldMessage = siteMessage("Enter a valid Email Address");

    const [contractorName, setcontractorName] = useState("");
    const [contractorNameError, setcontractorNameError] = useState(contractorNameRequiredFieldMessage);
    const [dateofSale, setDateofSale] = useState<any>();
    const [dateofSaleError, setDateofSaleError] = useState(dateofSaleRequiredFieldMessage);
    const [invoiceNumber, setinvoiceNumber] = useState("");
    const [invoiceNumberError, setinvoiceNumberError] = useState(invoiceNumberRequiredFieldMessage);
    const [equipmentType, setequipmentType] = useState("");
    const [equipmentTypeError, setequipmentTypeError] = useState(equipmentTypeRequiredFieldMessage);
    const [listedManufacturer, setlistedManufacturer] = useState("");
    const [modelNo, setModelNo] = useState("");
    const [centralAcSize, setCentralAcSize] = useState("");
    const [certificationNumber, setCertificationNumber] = useState("");
    const [listedManufacturerError, setlistedManufacturerError] = useState(listedManufacturerRequiredFieldMessage);
    const [businessName, setbusinessName] = useState("");
    const [businessNameError, setbusinessNameError] = useState(businessNameRequiredFieldMessage);
    const [instlLocationAdrs, setinstlLocationAdrs] = useState("");
    const [instlLocationAdrsError, setinstlLocationAdrsError] = useState(instlLocationAdrsRequiredFieldMessage);
    const [endUsrName, setendUsrName] = useState("");
    const [endUsrNameError, setendUsrNameError] = useState(endUsrNameRequiredFieldMessage);
    const [accntHldrphn, setaccntHldrphn] = useState("");
    const [accntHldrphnError, setaccntHldrphnError] = useState(accntHldrphnRequiredFieldMessage);
    const [accntHldrMail, setaccntHldrMail] = useState("");
    const [accntHldrMailError, setaccntHldrMailError] = useState(accntHldrMailRequiredFieldMessage);
    const [electricILAccnt, setelectricILAccnt] = useState("");
    const [electricILAccntError, setelectricILAccntError] = useState(electricILAccntRequiredFieldMessage);
    const [indiUnitsSold, setindiUnitsSoldAccnt] = useState("");
    const [indiUnitsSoldAccntError, setindiUnitsSoldAccntError] = useState(indiUnitsSoldrequiredFieldMessage);
    const [thermostatMdlNbr, setthermostatMdlNbr] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const toasterContext = useContext(ToasterContext);

    const validateContractorName = (name: string) => {
        const errorMessage = !name ? contractorNameRequiredFieldMessage : "";
        setcontractorNameError(errorMessage);
        return !errorMessage;
    };

    const validateDateofSale = (date: any) => {
        const errorMessage = !date ? dateofSaleRequiredFieldMessage : "";
        setDateofSaleError(errorMessage);
        return !errorMessage;
    };

    const validateCrescentInvoiceNumber = (value: string) => {
        const errorMessage = !value ? invoiceNumberRequiredFieldMessage : "";
        setinvoiceNumberError(errorMessage);
        return !errorMessage;
    };
    const validateEquipmentTypeNumber = (value: string) => {
        const errorMessage = !value ? invoiceNumberRequiredFieldMessage : "";
        setequipmentTypeError(errorMessage);
        return !errorMessage;
    };
    const validatelistedManufacturer = (name: string) => {
        const errorMessage = !name ? listedManufacturerRequiredFieldMessage : "";
        setlistedManufacturerError(errorMessage);
        return !errorMessage;
    };
    const validatebusinessName = (name: string) => {
        const errorMessage = !name ? businessNameRequiredFieldMessage : "";
        setbusinessNameError(errorMessage);
        return !errorMessage;
    };
    const validateinstlLocationAdrs = (name: string) => {
        const errorMessage = !name ? instlLocationAdrsRequiredFieldMessage : "";
        setinstlLocationAdrsError(errorMessage);
        return !errorMessage;
    };
    const validateendUsrName = (name: string) => {
        const errorMessage = !name ? endUsrNameRequiredFieldMessage : "";
        setendUsrNameError(errorMessage);
        return !errorMessage;
    };

    const addDashToPhone = (value: string) => {
        if (value.length > 6) {
            return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
        }
        if (value.length > 3 && value.length <= 6) {
            return `${value.slice(0, 3)}-${value.slice(3, 6)}`;
        }
        return value;
    };

    const removeDashFromPhone = (value: string) => {
        return value.replace(/\D/g, "");
    };
    const validateaccntHldrphn = (value: string) => {
        value = removeDashFromPhone(value);
        const errorMessage = !value
            ? accntHldrphnRequiredFieldMessage
            : Number(value) && value.length === 10
            ? ""
            : validPhoneMsg;
        setaccntHldrphnError(errorMessage);
        return !errorMessage;
    };
    const validateaccntHldrMail = (email: string) => {
        const errorMessage = !email
            ? accntHldrMailRequiredFieldMessage
            : emailRegexp.test(email)
            ? ""
            : emailFieldMessage;
        setaccntHldrMailError(errorMessage);
        return !errorMessage;
    };
    const validateelectricILAccnt = (name: string) => {
        const errorMessage = !name ? electricILAccntRequiredFieldMessage : "";
        setelectricILAccntError(errorMessage);
        return !errorMessage;
    };
    const validateindiUnitsSold = (value: string) => {
        const errorMessage = !value ? indiUnitsSoldrequiredFieldMessage : "";
        setindiUnitsSoldAccntError(errorMessage);
        return !errorMessage;
    };
    const validateSubmitEnabled = () => {
        return !(
            contractorNameError ||
            dateofSaleError ||
            invoiceNumberError ||
            equipmentTypeError ||
            listedManufacturerError ||
            businessNameError ||
            instlLocationAdrsError ||
            endUsrNameError ||
            accntHldrphnError ||
            accntHldrMailError ||
            electricILAccntError ||
            indiUnitsSoldAccntError
        );
    };

    const modelNoChangeHandler = (value: string) => {
        setModelNo(value);
    };

    const centralAcSizeChangeHandler = (value: string) => {
        setCentralAcSize(value);
    };

    const certificationNumberChangeHandler = (value: string) => {
        setCertificationNumber(value);
    };

    const contractorNameChangeHandler = (value: string) => {
        validateContractorName(value);
        setcontractorName(value);
    };
    const ThermostatMdlNbrChangeHandler = (value: string) => {
        // validateThermostatMdlNbr(value);
        setthermostatMdlNbr(value);
    };
    const dateofSaleChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        validateDateofSale(selectedDay);
        setDateofSale(convertDateToDateOnlyString(selectedDay));
    };
    const invoiceNumberChangeHandler = (value: string) => {
        validateCrescentInvoiceNumber(value);
        setinvoiceNumber(value);
    };
    const equipmentTypeChangeHandler = (value: string) => {
        validateEquipmentTypeNumber(value);
        setequipmentType(value);
    };
    const listedManufacturerChangeHandler = (value: string) => {
        validatelistedManufacturer(value);
        setlistedManufacturer(value);
    };
    const businessNameChangeHandler = (value: string) => {
        validatebusinessName(value);
        setbusinessName(value);
    };
    const instlLocationAdrsChangeHandler = (value: string) => {
        validateinstlLocationAdrs(value);
        setinstlLocationAdrs(value);
    };
    const endUsrNameChangeHandler = (value: string) => {
        validateendUsrName(value);
        setendUsrName(value);
    };
    const accntHldrphnChangeHandler = (value: string) => {
        const regex = /[0-9]|\./;
        if (!value) {
            setaccntHldrphn("");
            validateaccntHldrphn(value);
        }
        value = removeDashFromPhone(value);
        if (!regex.test(value) || value.length > 10) {
            return;
        }
        if (value) {
            const formattedPhone = addDashToPhone(value);
            formattedPhone !== undefined && setaccntHldrphn(formattedPhone);
            validateaccntHldrphn(formattedPhone);
        }
    };
    const accntHldrMailChangeHandler = (email: string) => {
        validateaccntHldrMail(email);
        setaccntHldrMail(email);
    };
    const electricILAccntChangeHandler = (value: string) => {
        validateelectricILAccnt(value);
        setelectricILAccnt(value);
    };
    const indiUnitsSoldChangeHandler = (value: string) => {
        validateindiUnitsSold(value);
        setindiUnitsSoldAccnt(value);
    };
    const onSuccessHandler = () => {
        setErrorMessage("");
        toasterContext.addToast({ body: translate("Successfully submitted!"), messageType: "success" });
        clearFormFields();
    };

    // eslint-disable-next-line require-await
    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            return;
        }

        setIsSubmitting(true);

        submitIncentive({
            ContractorBusinessName: contractorName,
            DateOfSale: dateofSale,
            CrescentInvoiceNumber: invoiceNumber,
            UnitSold: indiUnitsSold,
            TypeOfEquipemnt: equipmentType,
            ModelNumber: modelNo,
            ThermostatModelNumber: thermostatMdlNbr,
            Manufacturer: listedManufacturer,
            CentralACSize: centralAcSize,
            CertificationNumber: certificationNumber,
            BusinessName: businessName,
            LocationAddress: instlLocationAdrs,
            Name: endUsrName,
            PhoneNumber: accntHldrphn,
            Email: accntHldrMail,
            AccountNumber: electricILAccnt,
            onSuccess: onSuccessHandler,
            onError: error => {
                setErrorMessage(error);
                setIsSubmitting(false);
                const errorMsg = error.toString().length > 400 ? "Something went wrong!" : error;
                toasterContext.addToast({ body: translate(errorMsg), messageType: "danger" });
            },
        });
    };

    const clearFormFields = () => {
        setcontractorName("");
        setinvoiceNumber("");
        setDateofSale("");
        setindiUnitsSoldAccnt("");
        setequipmentType("");
        setlistedManufacturer("");
        setbusinessName("");
        setinstlLocationAdrs("");
        setendUsrName("");
        setaccntHldrphn("");
        setaccntHldrMail("");
        setelectricILAccnt("");
        setthermostatMdlNbr("");
        setModelNo("");
        setCertificationNumber("");
        setCentralAcSize("");
        setErrorMessage("");
        setIsSubmitted(false);
        setIsSubmitting(false);
        setcontractorNameError(contractorNameRequiredFieldMessage);
        setDateofSaleError(dateofSaleRequiredFieldMessage);
        setinvoiceNumberError(invoiceNumberRequiredFieldMessage);
        setequipmentTypeError(equipmentTypeRequiredFieldMessage);
        setlistedManufacturerError(listedManufacturerRequiredFieldMessage);
        setbusinessNameError(businessNameRequiredFieldMessage);
        setinstlLocationAdrsError(instlLocationAdrsRequiredFieldMessage);
        setendUsrNameError(endUsrNameRequiredFieldMessage);
        setaccntHldrphnError(accntHldrphnRequiredFieldMessage);
        setaccntHldrMailError(accntHldrMailRequiredFieldMessage);
    };

    const isSubmitEnabled = validateSubmitEnabled();

    return (
        <>
            <StyledForm {...styles.form} onSubmit={submitHandler}>
                <StyledWrapper>
                    <Zone contentId={id} zoneName="Content" />
                </StyledWrapper>
                <GridContainer {...styles.maincntr}>
                    <GridItem {...styles.itm1}>
                        <GridContainer {...styles.cntr1}>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="1. Contractor Business Name *"
                                    onChange={e => contractorNameChangeHandler(e.currentTarget.value)}
                                    value={contractorName}
                                    error={isSubmitted && contractorNameError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <DatePicker
                                    required
                                    error={isSubmitted && dateofSaleError}
                                    label="2. Date of sale (Date purchased at crecent) "
                                    selectedDay={convertDateOnlyStringToDate(dateofSale)}
                                    onDayChange={dateofSaleChangeHandler}
                                    dateTimePickerProps={{
                                        clearIcon: null,
                                        maxDate: new Date(),
                                    }}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="3. Crescent Invoice Number *"
                                    onChange={e => invoiceNumberChangeHandler(e.currentTarget.value)}
                                    value={invoiceNumber}
                                    error={isSubmitted && invoiceNumberError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <Select
                                    {...styles.txtfld}
                                    label="4. Individual Units Sold *"
                                    onChange={e => indiUnitsSoldChangeHandler(e.currentTarget.value)}
                                    value={indiUnitsSold}
                                    error={isSubmitted && indiUnitsSoldAccntError}
                                >
                                    <option value=""></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </Select>
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <Select
                                    {...styles.txtfld}
                                    label="5. Type of Equipments (Choose One) *"
                                    onChange={e => equipmentTypeChangeHandler(e.currentTarget.value)}
                                    value={equipmentType}
                                    error={isSubmitted && equipmentTypeError}
                                >
                                    <option value=""></option>
                                    <option value="Central AC (up to 65kBTU)">Central AC (up to 65kBTU)</option>
                                    <option value="Central AC (65kBTU to 135kBTU)">
                                        Central AC (65kBTU to 135kBTU)
                                    </option>
                                    <option value="Air Source Heat Pump">Air Source Heat Pump</option>
                                    <option value="Smart Themostat">Smart Themostat</option>
                                    <option value="AX Section Notched V-Belt">AX Section Notched V-Belt</option>
                                    <option value="BX Section Notched V-Belt">BX Section Notched V-Belt</option>
                                    <option value="Heat Pump Water Heater">Heat Pump Water Heater</option>
                                    <option value="Residential Ductless Heat Pump">
                                        Residential Ductless Heat Pump
                                    </option>
                                </Select>
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="6. Model Number"
                                    value={modelNo}
                                    onChange={e => modelNoChangeHandler(e.target.value)}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="7. (If Applicable) Thermostat model number"
                                    onChange={e => ThermostatMdlNbrChangeHandler(e.currentTarget.value)}
                                    value={thermostatMdlNbr}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="8. Listed Manufacturer *"
                                    onChange={e => listedManufacturerChangeHandler(e.currentTarget.value)}
                                    value={listedManufacturer}
                                    error={isSubmitted && listedManufacturerError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="9. Centeral AC Size (in kBTU). (This number can be found on the AHRI certificate)"
                                    value={centralAcSize}
                                    onChange={e => centralAcSizeChangeHandler(e.currentTarget.value)}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="10. AHRI Certification Number (for ACs and ASHPs):"
                                    onChange={e => certificationNumberChangeHandler(e.currentTarget.value)}
                                    value={certificationNumber}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="11. Business Name (or Homeowner) *"
                                    onChange={e => businessNameChangeHandler(e.currentTarget.value)}
                                    value={businessName}
                                    error={isSubmitted && businessNameError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="12. Full Installation Location Address (Street, City, State, Zip) *"
                                    onChange={e => instlLocationAdrsChangeHandler(e.currentTarget.value)}
                                    value={instlLocationAdrs}
                                    error={isSubmitted && instlLocationAdrsError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="13. Full Name of End User (Ameren Account Holder) *"
                                    onChange={e => endUsrNameChangeHandler(e.currentTarget.value)}
                                    value={endUsrName}
                                    error={isSubmitted && endUsrNameError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="14. Account Holder Phone *"
                                    onChange={e => accntHldrphnChangeHandler(e.currentTarget.value)}
                                    value={accntHldrphn}
                                    error={isSubmitted && accntHldrphnError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="15. Account Holder Email *"
                                    onChange={e => accntHldrMailChangeHandler(e.currentTarget.value)}
                                    value={accntHldrMail}
                                    error={isSubmitted && accntHldrMailError}
                                />
                            </GridItem>
                            <GridItem {...styles.gridItem}>
                                <TextField
                                    {...styles.txtfld}
                                    type="text"
                                    label="16. Ameren IL Electric Account Number *"
                                    onChange={e => electricILAccntChangeHandler(e.currentTarget.value)}
                                    value={electricILAccnt}
                                    error={isSubmitted && electricILAccntError}
                                />
                            </GridItem>
                            <StyledWrapper {...styles.button}>
                                <Button
                                    {...styles.submitButton}
                                    type="submit"
                                    disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
                                    data-test-selector="createAccount_createButton"
                                >
                                    {translate("Submit")}
                                </Button>
                            </StyledWrapper>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </StyledForm>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(IncentiveForm),
    definition: {
        group: "Common",
        displayName: "Incentive Form",
    },
};

export default widgetModule;
